import moment from "moment";
import {
  SETTINGS,
  USER_LOGGED_IN_DETAILS,
  SIDEBAR_SCROLL_POSITION,
  ACTIVE_SIDEBAR_MENU,
  ACTIVE_SITE_DETAIL_TAB,
  ACTIVE_LEAVE_REQUESTS_TAB,
  ACTIVE_AR_REQUESTS_TAB,
  ACTIVE_OD_REQUESTS_TAB,
  ACTIVE_EMP_ONBOARD_TAB,
  NOTIFICATIONS,
  NOTIFICATION_COUNT,
  ACTIVE_PURCHASE_TAB,
  ACTIVE_PURCHASE_REQUEST_TAB,
  ACTIVE_PURCHASE_ORDER_TAB,
  ACTIVE_PT_AGAINST_PO_TAB,
  ACTIVE_PT_GENERAL_TAB,
  ACTIVE_PT_REIMB_TAB,
  ACTIVE_PAYMENT_ADVISORY_TAB,
  ACTIVE_SALARY_HEAD_TAB,
  UPDATE_FILTERS_STATES,
  ACTIVE_STOCK_OUT_TAB,
  ACTIVE_GRN_TAB,
  ACTIVE_PAYMENT_OVERVIEW_TAB,
  ACTIVE_ATTENDANCE_SUMMARY_TAB,
  UPDATE_DATE_FILTERS
} from "../types";
import { getCurrentFinancialYear } from "../../utility/CommonFunctions";

const now = new Date();

const initialState = {
  userDetails: {},
  notifications: [],
  notificationCount: {},
  settings: {},
  scrollPosition: 0,
  activeSidebarTab: -1,
  activeSiteDetailTab: 1,
  activeLeaveRequestsTab: 1,
  activeArRequestsTab: 1,
  activeOdRequestsTab: 1,
  activeEmpOnboardTab: 1,
  activeAttendanceSummaryTab: 1,
  activePurchaseTab: "pendingPR",
  activePurchaseRequestTab: 1,
  activePurchaseOrderTab: "",
  activePtAgainstPoTab: "pending",
  activePtGeneralTab: "pending",
  activePtReimbTab: "pending",
  activePaymentAdvisoryTab: "paymentTicket",
  activeGrnTab: "pending",
  activeSalaryHeadTab: 1,
  activeStockOutTab: "pending",
  activePaymentOverdueTab: "overdue",
  filtersStates: {
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    paymentStatus: "",
    sortByDate: [
      moment(moment().subtract(30, "days").toDate()).format("YYYY-MM-DD"),
      moment(moment().toDate()).format("YYYY-MM-DD")
    ],
    year: getCurrentFinancialYear(),
    companyId: "",
    siteId: "",
    department: "",
    designation: "",
    requestType: "",
    stockStatus: "",
    vendorId: "",
    empStatus: "current",
    customerId: "",
    customerCompanyId: "",
    orderBy: "",
    due: ""
  },
  months: [
    moment().startOf("month").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ],
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGGED_IN_DETAILS: {
      return {
        ...state,
        userDetails: action.payload,
      };
    }
    case NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      };
    case NOTIFICATION_COUNT:
      return {
        ...state,
        notificationCount: action.payload,
      };
    case SETTINGS: {
      return {
        ...state,
        settings: action.payload,
      };
    }
    case SIDEBAR_SCROLL_POSITION:
      return {
        ...state,
        scrollPosition: action.payload,
      };
    case ACTIVE_SIDEBAR_MENU:
      return {
        ...state,
        activeSidebarTab: action.payload,
      };
    case ACTIVE_SITE_DETAIL_TAB:
      return {
        ...state,
        activeSiteDetailTab: action.payload,
      };
    case ACTIVE_LEAVE_REQUESTS_TAB:
      return {
        ...state,
        activeLeaveRequestsTab: action.payload,
      };
    case ACTIVE_AR_REQUESTS_TAB:
      return {
        ...state,
        activeArRequestsTab: action.payload,
      };
    case ACTIVE_OD_REQUESTS_TAB:
      return {
        ...state,
        activeOdRequestsTab: action.payload,
      };
    case ACTIVE_EMP_ONBOARD_TAB:
      return {
        ...state,
        activeEmpOnboardTab: action.payload,
      };
    case ACTIVE_PURCHASE_TAB:
      return {
        ...state,
        activePurchaseTab: action.payload,
      };
    case ACTIVE_PURCHASE_REQUEST_TAB:
      return {
        ...state,
        activePurchaseRequestTab: action.payload,
      };
    case ACTIVE_PURCHASE_ORDER_TAB:
      return {
        ...state,
        activePurchaseOrderTab: action.payload,
      };
    case ACTIVE_PT_AGAINST_PO_TAB:
      return {
        ...state,
        activePtAgainstPoTab: action.payload,
      };
    case ACTIVE_PT_GENERAL_TAB:
      return {
        ...state,
        activePtGeneralTab: action.payload,
      };
    case ACTIVE_PT_REIMB_TAB:
      return {
        ...state,
        activePtReimbTab: action.payload,
      };
    case ACTIVE_PAYMENT_ADVISORY_TAB:
      return {
        ...state,
        activePaymentAdvisoryTab: action.payload,
      };
    case ACTIVE_GRN_TAB:
      return {
        ...state,
        activeGrnTab: action.payload,
      };
    case ACTIVE_SALARY_HEAD_TAB:
      return {
        ...state,
        activeSalaryHeadTab: action.payload,
      };
    case ACTIVE_STOCK_OUT_TAB:
      return {
        ...state,
        activeStockOutTab: action.payload,
      };
    case ACTIVE_ATTENDANCE_SUMMARY_TAB:
      return {
        ...state,
        activeAttendanceSummaryTab: action.payload,
      };
    case ACTIVE_PAYMENT_OVERVIEW_TAB:
      return {
        ...state,
        activePaymentOverdueTab: action.payload,
      };
    case UPDATE_FILTERS_STATES:
      return {
        ...state,
        filtersStates: {
          ...state.filtersStates,
          ...action.payload,
        },
      };
    case UPDATE_DATE_FILTERS:
      return {
        ...state,
        months: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
